var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageStyleGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 67,
    viewBox: "0 0 80 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.625,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2713_6727)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9813 19.1934H45.25C45.0842 19.1934 44.9253 19.2592 44.8081 19.3764C44.6908 19.4936 44.625 19.6526 44.625 19.8184C44.625 19.9841 44.6908 20.1431 44.8081 20.2603C44.9253 20.3775 45.0842 20.4434 45.25 20.4434H46.9625C47.1283 20.4434 47.2872 20.3775 47.4044 20.2603C47.5217 20.1431 47.5875 19.9841 47.5875 19.8184C47.5875 19.6526 47.5217 19.4936 47.4044 19.3764C47.2872 19.2592 47.1283 19.1934 46.9625 19.1934H46.9813Z",
    fill: "url(#paint1_linear_2713_6727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9813 22.9434H45.25C45.0842 22.9434 44.9253 23.0092 44.8081 23.1264C44.6908 23.2436 44.625 23.4026 44.625 23.5684C44.625 23.7341 44.6908 23.8931 44.8081 24.0103C44.9253 24.1275 45.0842 24.1934 45.25 24.1934H46.9813C47.147 24.1934 47.306 24.1275 47.4232 24.0103C47.5404 23.8931 47.6063 23.7341 47.6063 23.5684C47.6063 23.4026 47.5404 23.2436 47.4232 23.1264C47.306 23.0092 47.147 22.9434 46.9813 22.9434Z",
    fill: "url(#paint2_linear_2713_6727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9805 26.6934H31.9805C31.8147 26.6934 31.6557 26.7592 31.5385 26.8764C31.4213 26.9936 31.3555 27.1526 31.3555 27.3184C31.3555 27.4841 31.4213 27.6431 31.5385 27.7603C31.6557 27.8775 31.8147 27.9434 31.9805 27.9434H46.9805C47.1462 27.9434 47.3052 27.8775 47.4224 27.7603C47.5396 27.6431 47.6055 27.4841 47.6055 27.3184C47.6055 27.1526 47.5396 26.9936 47.4224 26.8764C47.3052 26.7592 47.1462 26.6934 46.9805 26.6934Z",
    fill: "url(#paint3_linear_2713_6727)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9813 15.4434H45.25C45.0842 15.4434 44.9253 15.5092 44.8081 15.6264C44.6908 15.7436 44.625 15.9026 44.625 16.0684C44.625 16.2341 44.6908 16.3931 44.8081 16.5103C44.9253 16.6275 45.0842 16.6934 45.25 16.6934H46.9625C47.1283 16.6934 47.2872 16.6275 47.4044 16.5103C47.5217 16.3931 47.5875 16.2341 47.5875 16.0684C47.5875 15.9026 47.5217 15.7436 47.4044 15.6264C47.2872 15.5092 47.1283 15.4434 46.9625 15.4434H46.9813Z",
    fill: "url(#paint4_linear_2713_6727)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 19.1934H32.125C31.9592 19.1934 31.8003 19.2592 31.6831 19.3764C31.5658 19.4936 31.5 19.6526 31.5 19.8184C31.5 19.9841 31.5658 20.1431 31.6831 20.2603C31.8003 20.3775 31.9592 20.4434 32.125 20.4434H34C34.1658 20.4434 34.3247 20.3775 34.4419 20.2603C34.5592 20.1431 34.625 19.9841 34.625 19.8184C34.625 19.6526 34.5592 19.4936 34.4419 19.3764C34.3247 19.2592 34.1658 19.1934 34 19.1934Z",
    fill: "url(#paint5_linear_2713_6727)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 24.1934H34C34.1658 24.1934 34.3247 24.1275 34.4419 24.0103C34.5592 23.8931 34.625 23.7341 34.625 23.5684C34.625 23.4026 34.5592 23.2436 34.4419 23.1264C34.3247 23.0092 34.1658 22.9434 34 22.9434H32.125C31.9592 22.9434 31.8003 23.0092 31.6831 23.1264C31.5658 23.2436 31.5 23.4026 31.5 23.5684C31.5 23.7341 31.5658 23.8931 31.6831 24.0103C31.8003 24.1275 31.9592 24.1934 32.125 24.1934Z",
    fill: "url(#paint6_linear_2713_6727)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15.4434H32.125C31.9592 15.4434 31.8003 15.5092 31.6831 15.6264C31.5658 15.7436 31.5 15.9026 31.5 16.0684C31.5 16.2341 31.5658 16.3931 31.6831 16.5103C31.8003 16.6275 31.9592 16.6934 32.125 16.6934H34C34.1658 16.6934 34.3247 16.6275 34.4419 16.5103C34.5592 16.3931 34.625 16.2341 34.625 16.0684C34.625 15.9026 34.5592 15.7436 34.4419 15.6264C34.3247 15.5092 34.1658 15.4434 34 15.4434Z",
    fill: "url(#paint7_linear_2713_6727)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 12.9434H46.9812C47.147 12.9434 47.306 12.8775 47.4232 12.7603C47.5404 12.6431 47.6062 12.4841 47.6062 12.3184C47.6062 12.1526 47.5404 11.9936 47.4232 11.8764C47.306 11.7592 47.147 11.6934 46.9812 11.6934H32.125C31.9592 11.6934 31.8003 11.7592 31.6831 11.8764C31.5658 11.9936 31.5 12.1526 31.5 12.3184C31.5 12.4841 31.5658 12.6431 31.6831 12.7603C31.8003 12.8775 31.9592 12.9434 32.125 12.9434Z",
    fill: "url(#paint8_linear_2713_6727)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 15.625C37.2527 15.625 36.7758 15.8225 36.4242 16.1742C36.0725 16.5258 35.875 17.0027 35.875 17.5V22.5C35.875 22.9973 36.0725 23.4742 36.4242 23.8258C36.7758 24.1775 37.2527 24.375 37.75 24.375H41.5C41.9973 24.375 42.4742 24.1775 42.8258 23.8258C43.1775 23.4742 43.375 22.9973 43.375 22.5V17.5C43.375 17.0027 43.1775 16.5258 42.8258 16.1742C42.4742 15.8225 41.9973 15.625 41.5 15.625H37.75ZM42.125 17.5V22.5C42.125 22.6658 42.0592 22.8247 41.9419 22.9419C41.8247 23.0592 41.6658 23.125 41.5 23.125H37.75C37.5842 23.125 37.4253 23.0592 37.3081 22.9419C37.1908 22.8247 37.125 22.6658 37.125 22.5V17.5C37.125 17.3342 37.1908 17.1753 37.3081 17.0581C37.4253 16.9408 37.5842 16.875 37.75 16.875H41.5C41.6658 16.875 41.8247 16.9408 41.9419 17.0581C42.0592 17.1753 42.125 17.3342 42.125 17.5Z",
    fill: "url(#paint9_linear_2713_6727)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.289 63V52.948H1.161V63H3.289ZM7.12259 63V58.828C7.12259 57.708 7.73859 57.106 8.52259 57.106C9.37659 57.106 9.82459 57.736 9.82459 58.786V63H11.7566V58.828C11.7566 57.708 12.3866 57.106 13.1566 57.106C14.0106 57.106 14.4586 57.736 14.4586 58.786V63H16.3906V58.17C16.3906 56.378 15.3686 55.384 13.8566 55.384C12.7366 55.384 11.9806 55.888 11.3926 56.714C11.0146 55.86 10.2306 55.384 9.20859 55.384C8.21459 55.384 7.51459 55.832 6.96859 56.588V55.524H5.17659V63H7.12259ZM22.5075 63H24.0895V58.296C24.0895 56.462 22.9415 55.384 20.9815 55.384C19.1755 55.384 17.9295 56.504 17.8175 58.226H19.5675C19.6375 57.386 20.1415 56.896 20.9815 56.896C21.7935 56.896 22.2695 57.386 22.2695 58.226V58.674C21.8075 58.618 21.4435 58.59 21.0235 58.59C18.8395 58.59 17.6635 59.374 17.6635 60.83C17.6635 62.23 18.6995 63.14 20.2535 63.14C21.2755 63.14 22.0175 62.776 22.5075 62.076V63ZM19.4975 60.774C19.4975 60.102 20.0435 59.752 21.1495 59.752C21.4855 59.752 21.8075 59.78 22.2695 59.85V60.382C22.2695 61.25 21.6675 61.796 20.6735 61.796C19.9455 61.796 19.4975 61.404 19.4975 60.774ZM28.9444 65.842C31.1564 65.842 32.5004 64.638 32.5004 62.65V55.524H30.7224V56.546C30.1764 55.776 29.4204 55.384 28.4124 55.384C26.5644 55.384 25.2764 56.882 25.2764 59.052C25.2764 61.166 26.6484 62.72 28.4824 62.72C29.3924 62.72 30.1624 62.3 30.5684 61.586V62.678C30.5684 63.756 30.0084 64.33 28.9304 64.33C28.0064 64.33 27.4604 63.882 27.3764 63.028H25.5004C25.5844 64.75 26.9284 65.842 28.9444 65.842ZM27.2224 59.052C27.2224 57.834 27.8664 57.064 28.8604 57.064C29.8824 57.064 30.5544 57.848 30.5544 59.066C30.5544 60.242 29.8824 61.04 28.8604 61.04C27.8524 61.04 27.2224 60.27 27.2224 59.052ZM37.5047 63.126C39.3247 63.126 40.6267 62.16 41.0467 60.466H39.1147C38.8907 61.208 38.3167 61.628 37.4627 61.628C36.4687 61.628 35.8807 60.956 35.7547 59.738H41.0607C41.4107 57.302 39.8427 55.384 37.4767 55.384C35.3207 55.384 33.7667 57.008 33.7667 59.234C33.7667 61.572 35.2647 63.126 37.5047 63.126ZM37.4347 56.812C38.3587 56.812 38.9467 57.47 39.0027 58.506H35.7827C35.9507 57.4 36.5247 56.812 37.4347 56.812ZM53.1719 59.878C53.1719 58.394 52.2199 57.582 50.4559 57.232L48.7339 56.882C48.0059 56.742 47.3759 56.448 47.3759 55.762C47.3759 55.062 47.9639 54.474 48.9999 54.474C50.0639 54.474 50.7919 55.188 50.8619 56.238H53.0179C52.8779 54.138 51.2259 52.822 48.9719 52.822C46.8019 52.822 45.2199 54.11 45.2199 55.902C45.2199 57.568 46.3959 58.394 47.9219 58.688L49.5739 59.01C50.4279 59.178 50.9179 59.556 50.9179 60.186C50.9179 60.998 50.1479 61.474 49.0699 61.474C47.7679 61.474 47.0539 60.76 46.9979 59.654H44.8419C44.9959 61.782 46.5779 63.14 49.1119 63.14C51.6319 63.14 53.1719 61.796 53.1719 59.878ZM59.2758 61.11C58.9958 61.264 58.6598 61.348 58.2958 61.348C57.5958 61.348 57.2038 60.998 57.2038 60.13V57.19H59.3458V55.524H57.2038V53.312H55.2718V55.524H53.7598V57.19H55.2718V60.578C55.2718 62.258 56.2378 63.14 57.7778 63.14C58.3518 63.14 58.7998 63.042 59.2758 62.804V61.11ZM67.268 55.524H65.322L63.614 60.648L61.738 55.524H59.638L62.578 62.916L61.514 65.702H63.628L67.268 55.524ZM70.0819 63V52.948H68.1219V63H70.0819ZM75.075 63.126C76.895 63.126 78.197 62.16 78.617 60.466H76.685C76.461 61.208 75.887 61.628 75.033 61.628C74.039 61.628 73.451 60.956 73.325 59.738H78.631C78.981 57.302 77.413 55.384 75.047 55.384C72.891 55.384 71.337 57.008 71.337 59.234C71.337 61.572 72.835 63.126 75.075 63.126ZM75.005 56.812C75.929 56.812 76.517 57.47 76.573 58.506H73.353C73.521 57.4 74.095 56.812 75.005 56.812Z",
    fill: "url(#paint10_linear_2713_6727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2713_6727",
    x1: 59.625,
    y1: 37.4286,
    x2: 16.5146,
    y2: 32.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#356571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562876"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2713_6727",
    x1: 47.597,
    y1: 20.8113,
    x2: 45.0721,
    y2: 18.7223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2713_6727",
    x1: 47.6158,
    y1: 24.5614,
    x2: 45.088,
    y2: 22.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2713_6727",
    x1: 47.6577,
    y1: 28.3114,
    x2: 46.5774,
    y2: 23.4086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2713_6727",
    x1: 47.597,
    y1: 17.0614,
    x2: 45.0721,
    y2: 14.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2713_6727",
    x1: 34.635,
    y1: 20.8113,
    x2: 32.0883,
    y2: 18.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2713_6727",
    x1: 34.635,
    y1: 24.5614,
    x2: 32.0883,
    y2: 22.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2713_6727",
    x1: 34.635,
    y1: 17.0614,
    x2: 32.0883,
    y2: 14.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2713_6727",
    x1: 47.658,
    y1: 13.3114,
    x2: 46.569,
    y2: 8.41265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2713_6727",
    x1: 43.3991,
    y1: 26.9509,
    x2: 33.5161,
    y2: 23.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2713_6727",
    x1: 79.379,
    y1: 72.5935,
    x2: 42.8725,
    y2: 19.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageStyleGradient);
export default __webpack_public_path__ + "static/media/image_style_gradient.08bd22dfc22787b99d7305a255590f39.svg";
export { ForwardRef as ReactComponent };